import AdvocacySuccess from 'components/Campaigns/RwdAdvocacy/AdvocacyViews/AdvocacySuccess/AdvocacySuccess';
import { withAdvocacySuccessProps } from 'viewModel/Campaigns/RwdAdvocacy/AdvocacyViews/withAdvocacySuccessProps';

export default withAdvocacySuccessProps(AdvocacySuccess);
